import React, {useContext, useEffect, useState} from "react";
import {Button, Row, Col, Modal, Radio, notification, DatePicker, message, Alert, TimePicker} from "antd";
import '../modals.css';
import {distributionCenterService, trailService} from "../../../services";
import Spinner from "../../spinner";
import moment from "moment";
import SelectField from "../../select-field";
import {unloadingsService} from "../../../services/unloadings.services";
import FieldBlock from "../../field-block";
import { systemService } from "../../../services";
import localeDatePicker from "antd/lib/date-picker/locale/ru_RU";
import InputField from "../../input-field";
import DividerBlock from "../../divider-block";
import {AppContext} from "../../../contexts/app-context";
import NumberInputField from "../../number-input-field";
import i18n from "../../../i18n";
import {getTranslatedConstant, unloadPackageTypes} from "../../../helpers/translate.helpers";
import { MaskedInput } from "antd-mask-input";


export default function ModalCreateUnLoading({
                                                     isShow,
                                                     onCloseModal,
                                                   }) {

  const appContext = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [distCenters, setDistCenters] = useState([]);
  const [currentDistCenter, setCurrentDistCenter] = useState(null);

  const [fieldsErrors, setFieldsErrors] = useState([]);
  const [loadingTimes, setLoadingTimes] = useState(false);
  const [times, setTimes] = useState(null);

  const [carcassTypes, setCarcassTypes] = useState([]);
  const [translatedCarcassTypes, setTranslatedCarcassTypes] = useState([]);
  const [carcassTypesLoaded, setCarcassTypesLoaded] = useState(false);

  const [carcassTypeId, setCarcassTypeId] = useState(null);
  const [date, setDate] = useState(null);
  const [timeUnloading, setTimeUnloading] = useState(null);
  const [loadingType, setLoadingType] = useState(null);
  const [packageType, setPackageType] = useState(null);
  const [palletsCount, setPalletsCount] = useState(1);
  const [volume, setVolume] = useState('');
  const [phone, setPhone] = useState('');
  const [suplierName, setSuplierName] = useState(null);
  const [suplierINN, setSuplierINN] = useState(null);
  const [weight, setWeight] = useState(null);
  const [driverName, setDriverName] = useState(null);
  const [packageTypesList, setPackageTypesList] = useState(null);
  const [translatedPackageTypesList, setTranslatedPackageTypesList] = useState(null);


  const bigButtonStyle = {
    width: '200px',
    height: '43px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px'
  };

  const dividerStyle = {
    margin: '15px 0px 45px 0px',
    display: "block",
    clear: "both",
    width: "100%",
    minWidth: "100%",
    height: "1px"
  }

  const [loadingTypesList, setLoadingTypesList] = useState([]);

  useEffect(() => {
    setLoadingTypesList(getTranslatedConstant('loadingTypesList'));
    const translatedCarcassTypes = carcassTypes.map((item) => {
      return Object.assign({}, item, {title: i18n.t(`constants.mode.${item.id}`)})
    });
    setTranslatedCarcassTypes(translatedCarcassTypes);
    if (packageTypesList && packageTypesList.length > 0) {
      const translatedPackageTypes = packageTypesList.map((item) => {
        const type = Object.entries(unloadPackageTypes).filter((itemType) => {
          return itemType[1] === item;
        })[0]
        return {
          Id: item,
          Name: !!type ? i18n.t(`constants.unloadPackageTypes.${type[0]}`) : item
        };
      })
      setTranslatedPackageTypesList(translatedPackageTypes);
    }
  }, [appContext.lang.lang]);

  useEffect(() => {
    if (!carcassTypesLoaded) {
      trailService
        .getTrailTypes()
        .then((response) => {
          const translatedCarcassTypes = response.map((item) => {
            return Object.assign({}, item, {title: i18n.t(`constants.mode.${item.id}`)})
          });
          setCarcassTypes(response);
          setTranslatedCarcassTypes(translatedCarcassTypes);
          setCarcassTypesLoaded(true);
        })
        .catch((errorMsg) => {
          notification.error({
            message: i18n.t('components.notification.titles.getTrailTypes'),
            description: errorMsg,
          });
        });
    }
    if (!packageTypesList) {
      systemService.getPackageTypes()
        .then((response) => {
          const types = response.map((item) => {
            const type = Object.entries(unloadPackageTypes).filter((itemType) => {
              return itemType[1] === item;
            })[0]
            return {
              Id: item,
              Name: !!type ? i18n.t(`constants.unloadPackageTypes.${type[0]}`) : item
            };
          })
          setPackageTypesList(response);
          setTranslatedPackageTypesList(types);
        })
        .catch((errorMsg) => {
          notification.error({
            message: i18n.t('components.notification.titles.getPackageTypes'),
            description: errorMsg
          })
        })
    }
  }, []);

  useEffect(() => {
    if (distCenters.length === 0 && isShow) {
      distributionCenterService.getCompanies(true)
        .then((response) => {
          const distributionsCentersData = response.map((item) => {
            return {
              id: item.Id,
              name: item.Name,
            };
          });

          setDistCenters(distributionsCentersData);
          setLoading(false);

        }).catch((errMsg) => notification.error(
        {
          message: i18n.t('components.notification.titles.getCompanies2'),
          description: errMsg
        }));
    }
  }, [isShow])

  useEffect(() => {
    if (isShow &&
       currentDistCenter !== null &&
       date !== null &&
       loadingType !== null &&
       packageType !== null &&
       weight !== null &&
       carcassTypeId !== null
      ) {
      setError(null);
      setTimeUnloading(null);
      setTimes(null)
      setLoadingTimes(true);
      const dateUnloading = moment(date).format("YYYY-MM-DD");
      unloadingsService.getUnloadingTime(
        {
          DistCenterId: currentDistCenter,
          DateUnloading: dateUnloading,
          LoadingType: loadingType,
          PackageType: packageType,
          PalletsCount: palletsCount,
          CarcassTypeId: carcassTypeId,
          Weight: weight,
          Volume: volume
        }
      )
        .then((response) => {
          if (response.data.status === "error") {
            setError(response.data.message);
            notification.error({
              message: i18n.t('components.notification.titles.getUnloadingTime'),
              description: response.data.message,
            });
            return;
          }
          if (response.data.length === 0) {
            setError(i18n.t('modals.modalCreateUnLoading.errors.unloadingTime', {date: moment(date).format("DD-MM-YYYY")}));
            return;
          }
          setTimes(response.data);
          setLoadingTimes(false);
        })
        .catch((error) => {
          notification.error({
            message: i18n.t('components.notification.titles.getUnloadingTime2'),
            description: error,
          });
          setLoadingTimes(false);
        });
    }
  }, [currentDistCenter, isShow, date, loadingType, packageType, weight, volume, palletsCount, carcassTypeId]);

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField][0]
      : null;
  };

  const isButtonNotDisabled =  currentDistCenter !== null &&
    date !== null &&
    timeUnloading !== null &&
    suplierName !== null &&
    suplierINN !== null &&
    loadingType !== null &&
    carcassTypeId !== null &&
    weight !== null &&
    driverName !== null &&
    phone.length > 0 &&
    packageType !== null

  const onClickCreateUnloading = () => {
    unloadingsService.createUnloading(
      {
        DistributionCenterId: currentDistCenter,
        DateUnloading: moment(date).format("YYYY-MM-DD"),
        TimeUnloading: timeUnloading,
        SuplierName: suplierName,
        SuplierINN: suplierINN,
        LoadingType: loadingType,
        CarcassTypeId: carcassTypeId,
        Weight: weight,
        Volume: volume,
        PackageType: packageType,
        PalletsCount: palletsCount,
        DriverName: driverName,
        Phone: phone
      }
    )
      .then((response) => {
        if (response.data.status === 'error') {
          if (response.data.code === 400 && response.data.errors != null) {
            setFieldsErrors(response.data.errors);
          } else {
            setError(response.data.message);
            notification.error({
              message: i18n.t('components.notification.titles.createUnloading'),
              description: response.data.message,
             });
          }
        } else {
          setTimeUnloading(null);
          setDate(null);
          setTimes(null);
          notification.success({
            message: i18n.t('components.notification.titles.createUnloading'),
            description: response.data.message
          })
          appContext.setIsNeedUpdateUnloadingList(true);
          setFieldsErrors([]);
          onCloseModal(false);
        }
      }).catch((errorMsg) => {
      console.log(errorMsg);
    });
  }

  return (
    <Modal
      title={<span>{i18n.t('modals.modalCreateUnLoading.title')}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        onCloseModal();
      }}
      forceRender={true}
      footer={
        <Button htmlType="submit" key="submit" style={bigButtonStyle} type="primary" disabled={!isButtonNotDisabled}
                onClick={onClickCreateUnloading}>{i18n.t('main.buttons.add')}</Button>
      }
    >
      <Spinner loading={loading}>
        {error !== null &&
          <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
            <Col span={24}>
              <Alert message={<span style={{fontSize: 14}}>{error}</span>} type="error" />
            </Col>
          </Row>
        }
        <Row gutter={[16, 24]} style={{ marginBottom: "34px" }}>
          <Col lg={6} md={24} sm={24} sx={24}>
            <InputField
              name="suplierName" label={i18n.t('modals.modalCreateUnLoading.fields.suplierName.title')}
              value={suplierName} setValue={setSuplierName}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={6} md={24} sm={24} sx={24}>
            <NumberInputField
              name="suplierINN" label={i18n.t('modals.modalCreateUnLoading.fields.suplierINN.title')}
              value={suplierINN} setValue={setSuplierINN}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={12} md={24} sm={24} sx={24}>
            <SelectField
              name="distCenters" title={i18n.t('modals.modalCreateUnLoading.fields.distCenters.title')}
              placeholder={i18n.t('modals.modalCreateUnLoading.fields.distCenters.placeholder')}
              getErrors={() => {
              }}
              onChange={(value) => {
                setError(null)
                setCurrentDistCenter(distCenters.find((item) => item.id === value).id);
              }}
              style={{width: "100%"}}
              selectedValue={currentDistCenter}
              values={distCenters}/>
          </Col>
        </Row>
        <Row gutter={[16, 24]} style={{ marginBottom: "34px" }}>
          <Col lg={12} md={24} sm={24} xs={24} span={12}>
            <InputField
              name="driverName" label={i18n.t('modals.modalCreateUnLoading.fields.driverName.title')}
              value={driverName} setValue={setDriverName}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={12} md={24} sm={24} xs={24} span={12}>
            <InputField
              name="phone" label={i18n.t('modals.modalCreateUnLoading.fields.phone.title')}
              value={phone} setValue={setPhone}
              getFieldErrors={getFieldErrors}
            />
          </Col>
        </Row>
        <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
          <Col lg={8} md={24} sm={24} sx={24}>
            <SelectField
              title={i18n.t('modals.modalCreateUnLoading.fields.unloadingType.title')}
              name="loadingType"
              selectedValue={loadingType}
              values={loadingTypesList}
              onChange={value => {
                setLoadingType(value);
              }}
              getErrors={getFieldErrors}
              style={{width: "100%"}}
            />
          </Col>
          <Col lg={8} md={12} sm={24} sx={24}>
            <SelectField
              name="type"
              title={i18n.t('modals.modalCreateUnLoading.fields.carcassType.title')}
              values={translatedCarcassTypes}
              selectedValue={carcassTypeId}
              onChange={(value) => {
                setCarcassTypeId(value);
              }}
              getErrors={getFieldErrors}
              style={{width: "100%"}}
            />
          </Col>
          <Col lg={8} md={12} sm={24} sx={24}>
              <SelectField
                name={'packageType'}
                title={i18n.t('modals.modalCreateUnLoading.fields.loadingType.title')}
                values={translatedPackageTypesList}
                selectedValue={packageType}
                onChange={(value) => {
                  setPackageType(value);
                  if (value === 'Валом') {
                    setPalletsCount(0);
                  } else {
                    setPalletsCount(1);
                  }
                }}
                getErrors={getFieldErrors}
                style={{width: "100%"}}
              />
          </Col>
        </Row>
        <Row gutter={[16, 24]}>
          <Col lg={8} md={12} sm={24} xs={24}>
            <NumberInputField
              name="weight" label={i18n.t('modals.modalCreateUnLoading.fields.weight.title')}
              value={weight} setValue={setWeight}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={12} sm={24} sx={24}>
            <NumberInputField
              name="palletsCount" label={i18n.t('modals.modalCreateUnLoading.fields.palletsCount.title')}
              value={palletsCount} setValue={setPalletsCount}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={24} sm={24} sx={24}>
            <NumberInputField
              name="volume" label={i18n.t('consignorPage.createDelivery.content.volume')}
              value={volume} setValue={setVolume}
              getFieldErrors={getFieldErrors}
            />
          </Col>
        </Row>

          {distCenters.length > 0 &&
          <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
            <Col lg={8} md={12} sm={24} xs={24}>
              <FieldBlock name="date" title={i18n.t('modals.modalCreateUnLoading.fields.date.title')} getErrors={getFieldErrors}>
                <DatePicker
                  allowClear={false}
                  style={{width: "100%"}}
                  disabledDate={(current) => current && current < moment().startOf('day')}
                  defaultValue={date}
                  value={date}
                  format="DD.MM.YYYY"
                  size="large"
                  name="date"
                  locale={localeDatePicker}
                  onChange={value => {
                    setError(null);
                    setDate(value);
                  }}
                />
              </FieldBlock>
            </Col>
            <Col lg={8} md={12} sm={24} xs={24}>
                <FieldBlock name='selectedTime' title={i18n.t('modals.modalCreateUnLoading.fields.selectedTime.title')} getErrors={getFieldErrors}>
                  <MaskedInput
                    format="HH:mm" 
                    placeholder={i18n.t('modals.modalCreateUnLoading.fields.selectedTime.title')}
                    mask="11:11"
                    minLength={5}
                    size='large'
                    value={timeUnloading}
                    disabled={!(distCenters.length > 0 && times != null && times.length > 0)}
                    onChange={
                      (e) => {
                        let unm = e.target.value.replace(/[^0-9]/g, "");
                        if(unm.length !== 4) {
                          setTimeUnloading('');
                        } else {
                          setTimeUnloading(e.target.value)
                        }
                      }
                    }
                    onBlur={(e) => {
                      e.stopPropagation();
                      let unm = e.target.value.replace(/[^0-9]/g, "");
                      if(unm.length !== 4) {
                        e.target.value = '';
                      }
                    }}
                  />
                </FieldBlock>
            </Col>
            { times !== null && times.length > 0 &&
            <Col lg={8} md={12} sm={24} xs={24}>
              <Spinner loading={loadingTimes}>
                <FieldBlock name="time" title={i18n.t('modals.modalCreateUnLoading.fields.time.title')} getErrors={getFieldErrors}>
                  <Radio.Group
                    className="radio-group-primary" value={timeUnloading} name={'timeUnloading'}
                    buttonStyle={'outline'}>
                    {(times && times.length && date !== null) ? times.map((item, index) => {
                      // return <Radio.Button
                      //   key={index} value={item}
                      //   checked={item === timeUnloading}
                      //   style={{margin: "5px"}}
                      //   onClick={() => {
                      //     setError(null);
                      //   }}
                      // >{item}</Radio.Button>
                      return <>
                        <div key={`${index} ${item.StartTime}`} style={{margin: "5px"}}>
                          <span>{item.EndTime !== null ?
                            i18n.t('modals.modalCreateUnLoading.fields.interval.title', {start: item.StartTime, end: item.EndTime}) :
                            i18n.t('modals.modalCreateUnLoading.fields.intervalStart.title', {start: item.StartTime})}
                          </span>
                        </div>
                      </>
                    }) : null}
                    {(times === null || !times.length) && date !== null && distCenters && distCenters.length > 0 ?
                      <span>{i18n.t('modals.modalCreateUnLoading.fields.notAvailable.title')}</span> : null}
                  </Radio.Group>
                </FieldBlock>
              </Spinner>
            </Col>
            }
          </Row>
        }

        {
          times != null && times.length > 0 &&
          <Row>
            <p>{i18n.t('modals.modalCreateUnLoading.fields.customInterval.title')}</p>
          </Row>
        }
      </Spinner>
    </Modal>
  );
}
